<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="config.breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">水表名称：</span>
        </div>
        <el-input v-model="deviceName" size="small" style="width: 280px" />
        <span v-html="deviceNameVer"></span>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">水表序列号：</span>
        </div>
        <el-input v-model="code" size="small" style="width: 280px" disabled />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">水表厂家：</span>
        </div>
        <el-select v-model="deviceManufacturerCode" size="small" style="width: 280px">
          <el-option v-for="item in deviceManufacturerList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">水表型号：</span>
        </div>
        <el-select v-model="deviceModelCode" size="small" style="width: 280px">
          <el-option v-for="item in deviceModelNameList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">水表类型：</span>
        </div>
        <el-select v-model="waterDeviceType" size="small" style="width: 280px">
          <el-option v-for="item in waterDeviceTypeList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">接入方式：</span>
        </div>
        <el-select v-model="accessType" size="small" style="width: 280px">
          <el-option v-for="item in accessTypeList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line" v-if="accessType === '有线'">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">水表所属集中器：</span>
        </div>
        <el-select v-model="waterControlDeviceCode" size="small" style="width: 280px">
          <el-option v-for="item in waterList" :key="item.deviceCode"
                     :label="item.name" :value="item.deviceCode">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">倍率配置：</span>
        </div>
        <el-switch
          v-model="mutualInductorState"
          active-text="是"
          inactive-text="否">
        </el-switch>
      </div>

      <div class="form-line" v-if="mutualInductorState">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">倍率：</span>
        </div>
        <el-input-number v-model="powerRate" controls-position="right" size="small" style="width: 280px" :min="0" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">水表级别：</span>
        </div>
        <el-select v-model="level" size="small" style="width: 280px">
          <el-option v-for="item in levelList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line" v-if="level !== 1">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">上级水表：</span>
        </div>
        <el-select v-model="parentDeviceCode" filterable remote reserve-keyword placeholder="请输入关键词" size="small" style="width: 280px" :remote-method="selectWaterMeterParent">
          <el-option
            v-for="item in parentDeviceList"
            :key="item.code"
            :label="item.name"
            :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">水表所在房间：</span>
        </div>
        <input-tree :fetch="fetchDetail" :showCheckBox="false" @chooseLine="getRoomList" :theValue="roomCode" :theName="buildingRoomName" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">场景：</span>
        </div>
        <el-select v-model="scene" size="small" style="width: 280px">
          <el-option v-for="item in sceneList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line waterity">
        <div class="textBox">
          <!--<b class="red">*</b>-->
          <span class="line-text">初始水量：</span>
        </div>
        <el-input v-model="waterity" type="number" size="small" style="width: 280px" @blur="waterityBlur" disabled>
          <template slot="append">吨</template>
        </el-input>
        <span style="display: block;width: 400px;">初始水量为该水表新接入系统的初始度数，该度数作为后续用水的起始值，首次用水值=首次水表读数-该初始读数。一经添加无法修改，请仔细核对。</span>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">数据上报类型：</span>
        </div>
        <el-select v-model="useType" size="small" style="width: 280px">
          <el-option v-for="item in useTypeList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <!--      <div class="form-line">-->
      <!--        <div class="textBox">-->
      <!--          <b class="red">*</b>-->
      <!--          <span class="line-text">水表计费：</span>-->
      <!--        </div>-->
      <!--        <el-switch-->
      <!--          v-model="waterFeeTypeState"-->
      <!--          active-text="是"-->
      <!--          inactive-text="否">-->
      <!--        </el-switch>-->
      <!--      </div>-->

      <div class="form-line" v-if="autoOffSupportState">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">欠费是否关闸：</span>
        </div>
        <el-switch
          v-model="breaker"
          active-text="是"
          inactive-text="否">
        </el-switch>
      </div>

      <!--      <div class="form-line">-->
      <!--        <div class="textBox">-->
      <!--          <b class="red">*</b>-->
      <!--          <span class="line-text">水表数据统计：</span>-->
      <!--        </div>-->
      <!--        <el-switch-->
      <!--          v-model="whetherToCount"-->
      <!--          active-text="是"-->
      <!--          inactive-text="否">-->
      <!--        </el-switch>-->
      <!--      </div>-->

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">设备位置：</span>
        </div>
        <el-input v-model="location" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">备注：</span>
        </div>
        <el-input v-model="memo" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">责任人：</span>
        </div>
        <el-select v-model="responsiblePersonCode"
                   filterable
                   remote
                   clearable
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="remoteMethod"
                   placeholder="请输入关键词查询">
          <el-option v-for="item in responsiblePersonList" :key="item._value"
                     :label="item._label" :value="item._value">
          </el-option>
        </el-select>
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="add" />
        <button-cancel @cancel="strategyCenter" />
      </div>

    </form>
  </div>
</template>

<script>
import BreadCrumb from "../../../components/common/di-ding/common/bread-crumb";
import { errorHandler } from "../../../utils/errorHandler";
import InputTree from "../../../components/common/inputs/input-tree";
import { pattern } from "../../../utils/regular";
import { api } from "../../api/WaterManagement";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import { nError, nSuccess } from "../../../utils/notice";
import ButtonConfirmNext from "../../../components/Button/ButtonConfirmNext";
import { treeApi } from "../../api/ElectronicTreeApi";
// let a = document.getElementsByClassName()

export default {
  components: {
    ButtonConfirmNext,
    ButtonConfirm,
    ButtonCancel,
    TextTitle,
    Breadcrumb,
    InputTree,
    BreadCrumb
  },
  name: "ammeter-modify",
  data() {
    return {
      config: {
        breadcrumb: [
          {
            value: "智慧用水",
            name: "water-over-view"
          },
          {
            value: "水表管理"
          }
        ]
      },
      mainTitle: "修改水表",
      subheading: "",
      autoOffSupportState: false,
      code: "",
      deviceName: "",
      deviceNameVer: "<span>不超过32个字</span>",
      deviceManufacturerCode: "山科",
      deviceManufacturerList: [
        {
          name: "山科",
          code: "山科"
        },
        {
          name: "炬华",
          code: "炬华"
        }
      ],
      deviceModelCode: "DM-WD-001",
      deviceModelNameList: [
        {
          name: "DM-WD-001",
          code: "DM-WD-001"
        }
      ],
      waterDeviceType: "冷水",
      waterDeviceTypeList: [
        {
          name: "冷水",
          code: "冷水"
        },
        {
          name: "热水",
          code: "热水"
        }
      ],
      accessType: "",
      accessTypeList: [
        {
          name: "NB",
          code: "NB"
        },
        {
          name: "有线",
          code: "有线"
        },
        {
          name: "读表器",
          code: "读表器"
        },
        {
          name: "扫码接入",
          code: "扫码接入"
        }
      ],
      powerOnOrOff: "",
      waterControlDeviceCode: "",
      waterList: [],
      responsiblePersonCode: "",
      responsiblePersonList: [],
      responsiblePersonVer: "<span>水表责任人</span>",
      deviceNameHttp: false,
      deviceCodeHttp: false,
      fetchDetail: null,
      roomCode: "",
      roomName: "",
      buildingName: "",
      buildingCode: "",
      buildingRoomName: "",
      breaker: false,
      whetherToCount: false,
      waterFeeTypeState: false,
      scene: "",
      sceneList: [],
      useType: "",
      useTypeList: [
        {
          name: "自动上报",
          code: "1"
        },
        {
          name: "扫码上报",
          code: "2"
        }
      ],
      waterity: "0",
      powerBeforewaterMeter: "",
      memo: "",
      location: '',
      mutualInductorState: false,
      mutualInductorOnOrOff: "0",
      powerRate: 1,

      level: 1,
      levelList: [
        {
          name: "一级",
          code: 1
        },
        {
          name: "二级",
          code: 2
        },
        {
          name: "三级",
          code: 3
        },
        {
          name: "四级",
          code: 4
        },
        {
          name: "五级",
          code: 5
        }
      ],
      parentDeviceCode: "",
      parentDeviceName: "",
      parentDeviceList: []
    };
  },
  created() {
    this.autoOffSupport();
    // this.getAlldeviceManufacturer()
    // this.getAllDeviceType()
    // this.getResponsiblePersonList()
    this.code = this.$route.params.id;
    this.getWaterSceneList();
    this.getWaterControlDeviceList();
    this.remoteMethod()
    this.fetchDetail = () => {
      let treeList = [];
      let yqCode = "";

      return treeApi.getYqInfo().then(yqData => {
        let yqObj = {};
        yqCode = yqData.yqCode;
        yqObj._value = yqData.yqCode;
        yqObj._label = yqData.yqName;
        yqObj.parentCode = "0";
        yqObj.level = 1;
        yqObj.code = yqData.yqCode;
        treeList.push(yqObj);

        treeApi.getVacancyRoomInfo(this.currentCode).then(roomList => {
          roomList.map(room => {
            let roomObj = {};
            roomObj.buildingName = room.buildingName;
            roomObj.buildingCode = room.buildingCode;
            roomObj._value = room.code;
            roomObj._label = room.roomNumber;
            roomObj.parentCode = room.floorCode;
            roomObj.level = 4;
            roomObj.code = room.code;
            roomObj.roomArea = room.roomArea;
            roomObj.roomRent = room.roomRent;
            roomObj.roomType = room.roomType;
            treeList.push(roomObj);
          });
        });

        treeApi.getBuildingList().then(buildingList => {
          buildingList.map(v => {
            let obj = {};
            obj._value = v.code;
            obj._label = v.name;
            obj.parentCode = yqCode;
            obj.level = 2;
            obj.code = v.code;
            treeList.push(obj);
            if (v.floors.length > 0) {
              v.floors.map(floor => {
                let floorObj = {};
                floorObj._value = floor.code;
                floorObj._label = floor.name;
                floorObj.parentCode = floor.buildingCode;
                floorObj.level = 3;
                floorObj.code = floor.code;
                treeList.push(floorObj);
              });
            }
          });
        });
        return treeList;
      });
    };
  },
  methods: {
    // 查询是否可配置欠费是否关闸
    autoOffSupport() {
      this.$axios
        .get(api.autoOffSupport, {})
        .then(res => {
          this.autoOffSupportState = res.data.data;
        })
        .catch(errorHandler("查询配置信息失败"));
    },
    selectWaterMeterParent(query) {
      this.getWaterMeterParentList(query);
    },
    // 获取父级水表
    getWaterMeterParentList(query) {
      if (this.level !== 1) {
        this.$axios
          .post(api.getWaterMeterParentList, {
            level: this.level,
            searchKey: query || ""
          })
          .then(res => {
            let list = res.data.data;
            this.parentDeviceList = list;
          })
          .catch(errorHandler("获取父级水表失败"));
      }
    },
    // 获取场景列表
    getWaterSceneList() {
      this.$axios
        .post(api.getWaterSceneList, {})
        .then(res => {
          let list = res.data.data;
          this.sceneList = list;
        })
        .catch(errorHandler("获取场景列表失败"));
    },
    // 获取集中器列表
    getWaterControlDeviceList(searchKey) {
      this.$axios
        .post(api.getWaterControlDeviceList, {})
        .then(res => {
          let list = res.data.data;
          this.waterList = list;
          this.getWaterMeterDeviceByCode();
        })
        .catch(errorHandler("获取集中器列表失败"));
    },
    // 获取水表信息
    getWaterMeterDeviceByCode() {
      this.$axios
        .get(`${api.getWaterMeterDeviceByCode}/${this.code}`, {})
        .then(res => {
          let data = res.data.data;
          this.deviceName = data.name;
          this.waterDeviceType = data.waterDeviceType;
          this.accessType = data.accessType;
          this.deviceManufacturerCode = data.meterDeviceManufacturerCode;
          this.deviceModelCode = data.meterDeviceModelCode;
          this.waterControlDeviceCode = data.waterControlDeviceCode;
          this.roomName = data.roomNumber;
          this.roomCode = data.roomCode;
          this.buildingName = data.buildingName;
          this.buildingCode = data.buildingCode;
          if (data.buildingName && data.roomNumber) {
            this.buildingRoomName = `${data.buildingName}${data.roomNumber}`;
          }
          this.scene = data.sceneCode;
          this.useType = data.useType;
          this.powerOnOrOff = data.powerOnOrOff;
          this.whetherToCount = data.whetherToCount;
          this.waterity = data.waterity;
          if (data.autoOff === "1") {
            this.breaker = true;
          } else {
            this.breaker = false;
          }
          if (data.waterFeeType === "1") {
            this.waterFeeTypeState = true;
          } else {
            this.waterFeeTypeState = false;
          }
          if (data.whetherToCount === "1") {
            this.whetherToCount = true;
          } else {
            this.whetherToCount = false;
          }
          if (data.mutualInductorOnOrOff === "1") {
            this.mutualInductorState = true;
          } else {
            this.mutualInductorState = false;
          }
          this.memo = data.memo;
          this.powerRate = data.powerRate;
          this.location = data.location

          this.level = data.level;
          this.parentDeviceCode = data.parentDeviceCode;
          this.parentDeviceName = data.parentDeviceName;
          this.responsiblePersonCode=data.personCode
        })
        .catch(errorHandler("获取水表数据失败"));
    },
    // 获取责任人列表
    getResponsiblePersonList (searchKey) {
      this.$axios.post(`${api.getResponsiblePersonList}?searchKey=${searchKey || ''}`, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let list = res.data.data
            list.forEach(it => {
              it._value = it.code
              it._label = `${it.name} / ${it.phone}`
            })
            this.responsiblePersonList = list
          }
        })
        .catch(errorHandler('获取责任人列表失败'))
    },

    remoteMethod(query) {
      this.getResponsiblePersonList(query);
    },
    getRoomList(data) {
      console.log(data);
      if (data) {
        this.roomCode = data._value;
        this.roomName = data._label;
        this.buildingName = data.buildingName;
        this.buildingCode = data.buildingCode;
        this.buildingRoomName = `${data.buildingName}${data._label}`;
      } else {
        this.roomCode = "";
        this.roomName = "";
        this.buildingName = "";
        this.buildingCode = "";
        this.buildingRoomName = "";
      }
    },
    add() {
      if (!this.deviceName) {
        this.deviceNameVer = '<span style="color: red;">请输入水表名称</span>';
        return false;
      }
      if (!this.code) {
        nError("请输入水表序列号");
        return false;
      }
      if (this.accessType === "有线" && !this.waterControlDeviceCode) {
        nError("请选择水表所属集中器");
        return false;
      }
      if (this.level !== 1 && !this.parentDeviceCode) {
        nError("请选择上级水表");
        return false;
      }
      if (!this.scene) {
        nError("请选择场景");
        return false;
      }
      // if (!this.responsiblePersonCode) {
      //   this.responsiblePersonVer = '<span style="color: red;">请选择水表责任人</span>'
      //   return false
      // }
      if (!this.deviceNameHttp) {
        return false;
      } else {
        this.deviceNameVer = "<span>不超过32个字</span>";
      }
      let obj = {
        name: this.deviceName,
        code: this.code,
        waterDeviceType: this.waterDeviceType,
        accessType: this.accessType,
        waterControlDeviceCode: this.waterControlDeviceCode,
        waterControlDeviceName: "",
        meterDeviceManufacturerCode: this.deviceManufacturerCode,
        meterDeviceManufacturerName: "",
        meterDeviceModelCode: this.deviceModelCode,
        meterDeviceModelName: "",
        roomCode: this.roomCode,
        roomNumber: this.roomName,
        buildingCode: this.buildingCode,
        buildingName: this.buildingName,
        sceneCode: this.scene,
        sceneName: "",
        mutualInductorOnOrOff:this.mutualInductorOnOrOff,
        waterity: this.waterity,
        powerBeforewaterMeter: this.powerBeforewaterMeter,
        powerRate: this.powerRate,
        // responsiblePersonCode: this.responsiblePersonCode,
        // responsiblePersonName: '',
        // responsiblePersonPhone: '',
        autoOff: "0",
        waterFeeType: "0",
        whetherToCount: "0",
        memo: this.memo,
        location: this.location,
        useType: this.useType,

        level: this.level,
        parentDeviceCode: this.parentDeviceCode,
        parentDeviceName: this.parentDeviceName
      };
      if (this.breaker) {
        obj.autoOff = "1";
      } else {
        obj.autoOff = "0";
      }
      this.parentDeviceList.map(v => {
        if (v.code === this.parentDeviceCode) {
          obj.parentDeviceName = v.name;
        }
      });
      if (this.waterFeeTypeState) {
        obj.waterFeeType = "1";
      } else {
        obj.waterFeeType = "0";
      }
      if (this.whetherToCount) {
        obj.whetherToCount = "1";
      } else {
        obj.whetherToCount = "0";
      }
      this.sceneList.map(v => {
        if (v.code === this.scene) {
          obj.sceneName = v.name;
        }
      });
      if (obj.accessType === "NB") {
        obj.waterControlDeviceCode = "";
        obj.waterControlDeviceName = "";
      }
      this.waterList.map(v => {
        if (v.deviceCode === this.waterControlDeviceCode) {
          obj.waterControlDeviceName = v.name;
        }
      });
      this.deviceManufacturerList.map(v => {
        if (v.code === this.deviceManufacturerCode) {
          obj.meterDeviceManufacturerName = v.name;
        }
      });
      this.deviceModelNameList.map(v => {
        if (v.code === this.deviceModelCode) {
          obj.meterDeviceModelName = v.name;
        }
      });
      this.responsiblePersonList.map(v => {
        if (v.code === this.responsiblePersonCode) {
          obj.personName = v.name
          obj.personCode = v.code
          obj.responsiblePersonPhone = v.phone
        }
      })
      this.$axios
        .post(api.updateWaterMeterDevice, obj)
        .then(res => {
          nSuccess("修改成功");
          this.strategyCenter();
        })
        .catch(errorHandler("修改水表失败"));
    },
    strategyCenter() {
      this.$router.push({
        name: "water-ammeter-management"
      });
    }
  },
  watch: {
    deviceName(v) {
      let ptn = pattern.basicAndCN.test(v);
      if (!ptn) {
        this.deviceNameVer =
          '<span style="color: red;">只允许输入中文，字母，数字，下划线</span>';
        this.deviceNameHttp = false;
      } else {
        this.deviceNameVer = "<span>不超过32个字</span>";
        this.deviceNameHttp = true;
      }
    },
    mutualInductorState() {
      if (this.mutualInductorState) {
        this.mutualInductorOnOrOff = "1";
      } else {
        this.mutualInductorOnOrOff = "0";
        this.powerRate = 1;
      }
    },
    level() {
      this.getWaterMeterParentList();
    }
  }
};
</script>

<style scoped>
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #ff0000;
}
.form-line {
  margin: 15px 0;
}
.form-line > span {
  font-size: 12px;
  color: #97a8be;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 160px;
  text-align: right;
}
.form-btn-box {
  width: 605px;
  padding: 0 162px;
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/view/WaterManage/AmmeterManagement/AmmeterModify.vue